import React from 'react';

const MailBoxPage = () => {
  return <></>;
};

export default MailBoxPage;
